import { SignJWT } from 'jose';
import addHeaderClassesToHtml from './addHeaderClassesToHtml';

type GetDocumentBlobProps = {
  html: string;
  footerHtml?: string;
  watermarkText?: string;
  isLandscape?: boolean;
};

const fetchCss = async (path: string) => {
  const response = await fetch(path);
  return response.text();
};

const getStyles = async () => {
  const contentCss = await fetchCss('/styles/CKEditor/ck-content.css');
  const editorDefaultCss = await fetchCss('/styles/CKEditor/ckeditor5.css');
  const editorPremiumCss = await fetchCss(
    '/styles/CKEditor/ckeditor5-premium-features.css'
  );
  return `${contentCss}\n${editorDefaultCss}\n${editorPremiumCss}`;
};
const addWatermark = (html: string, watermarkText: string) => `
    <div style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-30deg);
        font-size: 5rem;
        color: rgba(0, 0, 0, 0.1);
        font-weight: bold;
        white-space: nowrap;
        z-index: 1000;
        pointer-events: none;
        user-select: none;
        width: 100vw;
        text-align: center;
    ">
        ${watermarkText}
    </div>
    ${html}
`;

export const getDocumentBlob = async ({
  html,
  footerHtml,
  watermarkText,
  isLandscape = false,
}: GetDocumentBlobProps): Promise<Blob> => {
  const accessKey = process.env.REACT_APP_CKEDITOR_ACCESS_KEY;

  const payload = {
    aud: process.env.REACT_APP_CKEDITOR_ENVIRONMENT_ID,
    iat: Math.floor(Date.now() / 1000),
  };

  const token = await new SignJWT(payload)
    .setProtectedHeader({ alg: 'HS256' })
    .sign(new TextEncoder().encode(accessKey));

  const styles = await getStyles();

  const htmWithHeader = addHeaderClassesToHtml(html);

  const resultHtml = addWatermark(htmWithHeader, watermarkText || '');

  const request = {
    html: resultHtml,
    css: styles,
    options: {
      format: 'A4',
      margin_top: '20mm',
      margin_bottom: '20mm',
      margin_right: '12mm',
      margin_left: '12mm',
      page_orientation: isLandscape ? 'landscape' : 'portrait',
      footer_html: footerHtml || '',
    },
  };

  const res = await fetch('https://pdf-converter.cke-cs.com/v1/convert', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(request),
  });

  const blob = await res.blob();

  return blob;
};
